// @flow
import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import type { StateType, DispatchType } from "../../../global/types/redux";
import UserList from "../../components/users/UserAdminList";
import { buildAdminUserItemJson } from "../../../account/components/companies/CompileCompanytoJson";
import {
  fetctAllUsers,
  fetctAllPrincipals,
  fetctGroupUsers
} from "../../actions/userAdminActions";
import { StyledSelect, GeneralModalForm, SnackbarMessage, NoItem } from "imagus-components";
import ChipInput from "../../../global/components/ChipInput";
import { LoadingProgress, SingleSwitch } from "imagus-components";
import { companyDialogMessages } from "../../../account/components/companies/CompileCompanytoJson";
import { ErrosDisplay } from "../../../account/containers/ErrosDisplay";
import type { ErrorsType } from "../../../account/types/UserFormType";
import { propComparator } from "../../../global/functions/StringOperations";
import CreateUserFormRedux from "../../../account/containers/users/CreateUserFormRedux";

import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import PersonAddIcon from "@material-ui/icons/PersonAdd";

type AdminProjectsStateType = {
  messageId: number,
  isFilterOpen: boolean,
  order: "userName" | "companyName" | "facebaseName",
  suquence: "asc" | "desc",
  companies: Array<string>,
  status: string,
  group: string,
  errors: ErrorsType,
  modalOpen: boolean,
  snackOpen: boolean
};

class AdminUsers extends Component<*, AdminProjectsStateType> {
  constructor(props) {
    super(props);
    this.state = {
      messageId: 0,
      isFilterOpen: true,
      order: "userName",
      suquence: "asc",
      companies: [],
      status: "ALL",
      group: "ALL",
      errors: {},
      modalOpen: false,
      snackOpen: false
    };
  }

  switchModalStatus = (modalName: string): * => (status: boolean): * => {
    this.setState({ [modalName]: status });
  };

  componentDidMount() {
    if (this.props.users === null) {
      this.props.actions.fetctAllUsers();
    }
    if (this.props.groups === null) {
      this.props.actions.fetctAllPrincipals();
    }
  }

  openSnackbar = (messageId: number): * => {
    this.setState(
      { messageId: messageId },
      this.switchModalStatus("snackOpen")(true)
    );
  };

  setActionError = (errors: ErrorsType): * => {
    this.setState({
      errors: errors
    });
  };

  handleTypeChange = (e: SyntheticInputEvent<*>): * => {
    const name = e.target.name;
    const value = e.target.value;
    this.setState(
      { [name]: value },
      (): * => {
        if (name === "group" && value !== "ALL") {
          this.props.actions.fetctGroupUsers(value);
        }
      }
    );
  };

  syncChange = (name: string, value: Array<*>): * => {
    this.setState({ [name]: value });
  };

  handleTextChange = (e: Event & { currentTarget: HTMLInputElement }): * => {
    const name = e.currentTarget.name;
    const value = e.currentTarget.value;
    this.setState({
      [name]: value
    });
  };

  handleSwitchChange = (event: Event): * => {
    const name = event.target.name;
    const value = event.target.checked;
    this.setState({
      [name]: value
    });
  };

  render(): * {
    let users = null;
    if (this.props.users) {
      if (this.state.group === "ALL") {
        users = { ...this.props.users };
      } else {
        if (this.props.groupUsers) {
          users = Object.keys(this.props.users)
            .filter((key: string): * => key in this.props.groupUsers)
            .map((key: string): * => this.props.users[key]);
        }
      }
    }

    let userNode = null;
    let companyList = [];
    let userList = [];
    if (users) {
      if (users.length === 0) {
        userNode = <NoItem content="No User has created yet." />;
      } else {
        for (let key in users) {
          let index = companyList.findIndex(
            x => x.value === users[key].company_uuid
          );
          if (index < 0) {
            companyList.push({
              value: users[key].company_uuid,
              label: users[key].company
            });
          }
          userList.push(buildAdminUserItemJson(users[key]));
        }
        companyList.sort(propComparator("label", true));

        if (this.state.order === "userName") {
          userList.sort(propComparator("fullName", true));
        } else if (this.state.order === "companyName") {
          userList.sort(propComparator("company", true, "name"));
        } else if (this.state.order === "facebaseName") {
          userList.sort(propComparator("facebase", true, "name"));
        }

        if (this.state.suquence === "desc") {
          userList.reverse();
        }

        userNode = (
          <UserList
            users={userList}
            openSnackbar={this.openSnackbar}
            setActionError={this.setActionError}
            companyFilter={this.state.companies}
            statusFilter={this.state.status}
          />
        );
      }
    }

    const OrderList = [
      { value: "userName", label: "User Name" },
      { value: "companyName", label: "Company Name" },
      { value: "facebaseName", label: "Facebase Name" }
    ];
    const SequenceList = [
      { value: "asc", label: "Ascending" },
      { value: "desc", label: "Descending" }
    ];
    const StatusList = [
      { value: "ALL", label: "ALL" },
      { value: "CONFIRMED", label: "Confirmed" },
      { value: "UNCONFIRMED", label: "Unconfirmed" }
    ];

    let GroupList = [{ value: "ALL", label: "ALL" }];
    this.props.groups &&
      this.props.groups.map(
        (group: string): * => {
          GroupList.push({ value: group.name, label: group.name });
        }
      );

    if (!userNode) {
      return (
        <div className="app-panel">
          <LoadingProgress />
        </div>
      );
    } else {
      return (
        <div className="app-panel">
          <div className="top-banner">
            <ErrosDisplay errors={this.state.errors} form="admin users" />
          </div>
          <SnackbarMessage
            open={this.state.snackOpen}
            handleModalStatus={this.switchModalStatus("snackOpen")}
            message={companyDialogMessages[this.state.messageId]}
          />
          <div className="app-panel-content">
            <Paper elevation={4} style={{ padding: "16px " }}>
              <SingleSwitch
                value={this.state.isFilterOpen}
                name="isFilterOpen"
                isRequired={false}
                label={["Show Criteria", "Hide Criteria"]}
                handleChange={this.handleSwitchChange}
              />
              <Button
                type="button"
                variant="contained"
                color="primary"
                className="dark-btn"
                style={{ float: "right" }}
                onClick={(): Function =>
                  this.switchModalStatus("modalOpen")(true)
                }
              >
                <PersonAddIcon className="light-icon right-margin-5" />
                Invite User
              </Button>
              <GeneralModalForm
                title="Invite User"
                open={this.state.modalOpen}
                handleModalStatus={this.switchModalStatus("modalOpen")}
                form={
                  <CreateUserFormRedux
                    onClose={(): * =>
                      this.switchModalStatus("modalOpen")(false)
                    }
                    openSnackbar={(): * => this.openSnackbar(13)}
                    isAdmin
                    isUserAdmin
                  />
                }
              />
              {this.state.isFilterOpen && (
                <Grid container spacing={24}>
                  <Grid item xs={12} md={6}>
                    <StyledSelect
                      value={this.state.order}
                      onChange={this.handleTypeChange}
                      name="order"
                      label="Order By"
                      isRequired={true}
                      menus={OrderList}
                      isStyled
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <StyledSelect
                      value={this.state.suquence}
                      onChange={this.handleTypeChange}
                      name="suquence"
                      label="Ascend | Descend"
                      isRequired={true}
                      menus={SequenceList}
                      isStyled
                    />
                  </Grid>
                  <Grid item xs={12} md={6} className="top-margin-10">
                    <ChipInput
                      name="companies"
                      label="Select Companies"
                      isMultiple
                      placeholder="All Companies"
                      tags={companyList}
                      value={this.state.companies}
                      syncChange={this.syncChange}
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <StyledSelect
                      value={this.state.status}
                      onChange={this.handleTypeChange}
                      name="status"
                      label="User Status"
                      isRequired={true}
                      menus={StatusList}
                      isStyled
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <StyledSelect
                      value={this.state.group}
                      onChange={this.handleTypeChange}
                      name="group"
                      label="User Groups"
                      isRequired={true}
                      menus={GroupList}
                      isStyled
                    />
                  </Grid>
                </Grid>
              )}
            </Paper>
          </div>
          {userNode}
        </div>
      );
    }
  }
}

const mapStateToProps = (state: StateType): * => ({
  users: state.v3admin.user.users,
  groups: state.v3admin.user.groups,
  groupUsers: state.v3admin.user.groupUsers
});

const mapDispatchToProps = (dispatch: DispatchType): DispatchType => ({
  actions: bindActionCreators(
    { fetctAllUsers, fetctAllPrincipals, fetctGroupUsers },
    dispatch
  )
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AdminUsers);
